import React, { createContext, useContext, useEffect, useState } from 'react';
import {
	getCapitalMarketBenchmarkVendorAnalysis,
	getBreakDownFilterColumnsForCapitalMarketBenchmark,
	getBreakDownFilterForCapitalMarketBenchmark,
	getCapitalMarketBenchmarkCategoryAnalysis,
} from 'utils/apiRequests';

const Benchmark = createContext();

export const BenchmarkProvider = ({ children }) => {
	const [breakDownFilters, setbreakDownFilters] = useState([]);
	const [currentBreakDownFilter, setCurrentBreakDownFilter] = useState('');
	const [
		currentBreakDownFilterCategory,
		setCurrentBreakDownFilterCategory,
	] = useState('');
	const [payload, setPayload] = useState({});
	const [currentFilterOptions, setcurrentFilterOptions] = useState([]);
	const [
		currentFilterOptionsCategory,
		setcurrentFilterOptionsCategory,
	] = useState([]);
	const [
		currentFilterValuesSelected,
		setcurrentFilterValuesSelected,
	] = useState([]);
	const [
		currentFilterValuesSelectedCategory,
		setcurrentFilterValuesSelectedCategory,
	] = useState([]);
	const [vendorsData, setVendorsData] = useState([]);
	const [categoryAnalysisData, setCategoryAnalysisData] = useState([]);
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		getFilters();
	}, []);

	useEffect(
		() => {
			if (currentBreakDownFilter.value) {
				applyVendorFilters();
			}
		},
		[currentFilterValuesSelected]
	);

	useEffect(
		() => {
			if (currentBreakDownFilterCategory.value) {
				let newPayload = payload;
				newPayload.Dimension = currentBreakDownFilterCategory.value;
				newPayload.Values = currentFilterValuesSelectedCategory;
				newPayload.flag = 0;
				setPayload(prevState => ({
					...prevState,
					...newPayload,
				}));
				getCategoryAnalysis(newPayload);
			}
		},
		[currentFilterValuesSelectedCategory]
	);

	async function applyVendorFilters(dimension = '') {
		try {
			setIsLoading(true);
			let payload = {
				Dimension: dimension ? dimension : currentBreakDownFilter.value,
				Values: currentFilterValuesSelected,
			};
			let response = await getCapitalMarketBenchmarkVendorAnalysis(payload);
			if (response.data?.length > 0) {
				setVendorsData(response.data);
			}
			setIsLoading(false);
		} catch (error) {
			console.log(error, 'Error Message');
			setIsLoading(false);
		}
	}

	async function getFilters() {
		try {
			let response = await getBreakDownFilterColumnsForCapitalMarketBenchmark();
			let formattedResponse = response.data?.map(item => {
				item.label = item.label.split('_').join(' ');
				return item;
			});
			setbreakDownFilters(formattedResponse);
			setCurrentBreakDownFilter(formattedResponse[0]);
			setCurrentBreakDownFilterCategory(formattedResponse[0]);
			getBreakDownFilter(formattedResponse[0].value, 'initial');
			applyVendorFilters(formattedResponse[0].value);
			let payload = {
				Dimension: formattedResponse[0].value,
				Values: [],
				flag: 0,
			};
			setPayload(payload);
			getCategoryAnalysis(payload);
		} catch (error) {
			console.log(error, 'Error Message');
		}
	}

	const getBreakDownFilter = async (value, isCategory = '') => {
		const payload = { dimension: value };
		const response = await getBreakDownFilterForCapitalMarketBenchmark(payload);
		if (response.succeeded) {
			if (!isCategory) {
				setcurrentFilterOptions(
					response.data.map(data => ({ label: data, value: data }))
				);
			} else if (isCategory === 'initial') {
				setcurrentFilterOptions(
					response.data.map(data => ({ label: data, value: data }))
				);
				setcurrentFilterOptionsCategory(
					response.data.map(data => ({ label: data, value: data }))
				);
			} else {
				setcurrentFilterOptionsCategory(
					response.data.map(data => ({ label: data, value: data }))
				);
			}
		}
	};

	function findAndModifyData(
		arr,
		targetId,
		targetLevel,
		targetGroup,
		newChildren
	) {
		for (const obj of arr) {
			if (
				obj.name === targetId &&
				obj.level === targetLevel &&
				obj.group === targetGroup
			) {
				obj.children = newChildren;
				obj.isExpanded = true;
				return true;
			}
			if (obj.children && obj.children.length > 0) {
				if (
					findAndModifyData(
						obj.children,
						targetId,
						targetLevel,
						targetGroup,
						newChildren
					)
				) {
					return true;
				}
			}
		}
		return false;
	}

	const getCategoryAnalysis = async (payload, isDrilldown = '') => {
		try {
			setIsLoading(true);
			let response = await getCapitalMarketBenchmarkCategoryAnalysis(payload);
			if (response.data?.length > 0) {
				const result = response.data.map(el => {
					return {
						...el,
						qmin:
							el.qmin <= 0.05
								? Number(el.qmin.toFixed(2))
								: Number(el.qmin.toFixed(1)),
						qmax: Number(el.qmax.toFixed(1)),
						qmedian: Number(el.qmedian.toFixed(1)),
						children: [],
						isExpanded: false,
						parent: el.parent === 'TOP' ? el.name : el.parent,
						L1Category: payload.L1Category,
						L2Category: payload.L2Category,
						L3Category: payload.L3Category,
					};
				});

				if (isDrilldown) {
					const newData = categoryAnalysisData;

					findAndModifyData(
						newData,
						payload.name,
						payload.flag,
						payload.group,
						result
					);

					setCategoryAnalysisData(newData);
				} else {
					setCategoryAnalysisData(result);
				}
			} else {
				setCategoryAnalysisData([]);
			}
			setIsLoading(false);
		} catch (error) {
			console.log(error, 'Error Message');
			setIsLoading(false);
		}
	};

	const handleFilterByChange = e => {
		setCurrentBreakDownFilter(e);
		getBreakDownFilter(e.value);

		setcurrentFilterValuesSelected([]);
	};

	const handleFilterByChangeCategory = e => {
		setCurrentBreakDownFilterCategory(e);
		getBreakDownFilter(e.value, true);

		setcurrentFilterValuesSelectedCategory([]);
	};

	const onExpand = (categoryGroup, categoryLevel, categoryName, rowObj) => {
		let newPayload = payload;
		setIsLoading(true);
		newPayload.Dimension = currentBreakDownFilterCategory.value;
		newPayload.Values = currentFilterValuesSelectedCategory;
		newPayload.name = categoryName;
		newPayload.group = categoryGroup;
		if (categoryLevel === 1) {
			newPayload.L1Category = categoryName;
			newPayload.flag = categoryLevel;
			setPayload(prevState => ({
				...prevState,
				...newPayload,
			}));
			getCategoryAnalysis(newPayload, true);
		} else if (categoryLevel === 2) {
			newPayload.L1Category = rowObj.L1Category;
			newPayload.L2Category = categoryName;
			newPayload.flag = categoryLevel;
			setPayload(prevState => ({
				...prevState,
				...newPayload,
			}));
			getCategoryAnalysis(newPayload, true);
		} else if (categoryLevel === 3) {
			newPayload.L1Category = rowObj.L1Category;
			newPayload.L2Category = rowObj.L2Category;
			newPayload.L3Category = categoryName;
			newPayload.flag = categoryLevel;
			setPayload(prevState => ({
				...prevState,
				...newPayload,
			}));
			getCategoryAnalysis(newPayload, true);
		} else {
			newPayload.flag = categoryLevel;
			setPayload(prevState => ({
				...prevState,
				...newPayload,
			}));
			getCategoryAnalysis(newPayload, true);
		}
	};

	function updateIsExpanded(data, name, level, group, isExpanded) {
		for (const item of data) {
			if (item.name === name && item.level === level && item.group === group) {
				item.isExpanded = !isExpanded;
				return true;
			}
			if (item.children && item.children.length > 0) {
				if (updateIsExpanded(item.children, name, level, group, isExpanded)) {
					return true;
				}
			}
		}
		return false;
	}

	const onToggle = (categoryLevel, categoryName, group, expandedFlag) => {
		const newData = categoryAnalysisData;
		updateIsExpanded(newData, categoryName, categoryLevel, group, expandedFlag);
		setCategoryAnalysisData([...newData]);
	};

	return (
		<Benchmark.Provider
			value={{
				vendorsData,
				setVendorsData,
				isLoading,
				applyVendorFilters,
				breakDownFilters,
				setbreakDownFilters,
				currentBreakDownFilter,
				currentBreakDownFilterCategory,
				setCurrentBreakDownFilter,
				setCurrentBreakDownFilterCategory,
				handleFilterByChangeCategory,
				currentFilterOptions,
				currentFilterOptionsCategory,
				currentFilterValuesSelectedCategory,
				setcurrentFilterValuesSelectedCategory,
				setcurrentFilterOptions,
				setcurrentFilterOptionsCategory,
				currentFilterValuesSelected,
				setcurrentFilterValuesSelected,
				handleFilterByChange,
				getBreakDownFilter,
				categoryAnalysisData,
				onExpand,
				onToggle,
			}}
		>
			{children}
		</Benchmark.Provider>
	);
};

export const useBenchmarkContext = () => {
	return useContext(Benchmark);
};
